<template>
  <div class="input-wrapper hd">
    <slot :searchData="searchData" :condition="condition" :pickerOptions="pickerOptions"
      :filterDownData="filterDownData" />
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'
import filterDownData from 'mixins/filterDownData'

export default {
  name: 'SearchComponent',
  mixins: [pickerOptions, filterDownData],
  props: {
    condition: {
      type: Object,
      default: () => {
        return {}
      }
    },
    routeName: {
      type: String
    },
    source: {
      type: [String, Number]
    }
  },
  methods: {
    /**
     * 搜索
     */
    searchData() {
      const condition = this._returnSearchConditon()
      this.$emit('updateData', vm => {
        switch (this.routeName) {
          case 'accountStatement':
            if (this.source !== 0) {
              condition.bill_source = this.source
            }

            vm._getAccountStatementList(condition)
            break
          case 'distributorCommission':
            condition.search_model = this.source
            vm._getFinanceOrderList(condition)
            break
          case 'newAccountStatement':
            vm._getFinanceOrderList(condition)
            break
          case 'invoiceManagement':
            condition.search_model = this.source
            vm._getFinanceOrderList(condition)
            break
          case 'orderExpert':
            condition.search_model = this.source
            vm._getFinanceOrderList(condition)
            break
        }
      })
    },
    /**
     * 返回搜索条件
     * @private
     */
    _returnSearchConditon() {
      const {
        statementName,
        singleNumber,
        time,
        orderNumber,
        sku,
        goodsName,
        orderSource,
        paymentType,
        refundType,
        distributorAccount,
        platformId,
        orderAttribution,
        appletsId
      } = this.condition

      let data = {
        bill_name: statementName,
        bill_no: singleNumber,
        start_time: typeof time !== 'undefined' ? time[0] : '',
        end_time: typeof time !== 'undefined' ? time[1] : '',
        pay_sn: orderNumber,
        goods_sku: sku,
        goods_name: goodsName,
        order_source: orderSource,
        payment_code: paymentType,
        refund_type: refundType,
        distributor_name: distributorAccount,
        platform_id: platformId,
        order_merchant_id: orderAttribution,
        applet_id: appletsId
      }
      this.utils._checkSearchCondition(data)
      return data
    }
  }
}
</script>
